/**
 * ordinal.js — 1st, 2nd, 3rd, 4th, and the 11th-13th exception that every naive
 * version of this gets wrong.
 *
 * 🔴 THIS EXISTS BECAUSE THE PAGE SHIPPED "2th percentile" AND "0th percentile"
 * (Ben's screenshot, Aug 30). The group cards were interpolating a plain "th"
 * onto a rounded number, so every 1, 2 and 3 came out broken and the bottom of
 * the corpus read as a zero. There is ONE helper and every ordinal on the site
 * goes through it.
 *
 * 🔴 IT LIVES IN utils/ RATHER THAN IN CorpusMeter (Sep 2 2026). It was written
 * for percentile lines and then wanted by the room report's rank badges, which
 * are built in a util — and a util reaching into a component for a string
 * helper is how a second copy gets written instead. CorpusMeter re-exports it,
 * so every existing import and its own test are untouched.
 */
export function ordinal(n) {
  const v = Math.round(n);
  const abs = Math.abs(v);
  // 11, 12 and 13 are "th" despite ending in 1, 2 and 3 — and so are 111, 112
  // and 113, which is why the test is on the last TWO digits, not the last one.
  const tens = abs % 100;
  if (tens >= 11 && tens <= 13) return `${v}th`;
  switch (abs % 10) {
    case 1:
      return `${v}st`;
    case 2:
      return `${v}nd`;
    case 3:
      return `${v}rd`;
    default:
      return `${v}th`;
  }
}
